import { JobApplicationStatus } from '../../job-application/models/job-application-status.model';
import { JobApplication } from '../../job-application/models/job-application.model';
import { BaseService } from '../../../../../core/services/base.service';
import { FeatureJobApplications } from '../models/featurejobapplications.model';

export class FeatureJobApplicationsService {
  static async GetApplications(
    params?: {
      page?: number;
      size?: number;
      sort?: string;
      filter?: string;
    },
    CallbackCatch?: (error: Error) => void
  ): Promise<{ content: FeatureJobApplications[]; totalElements: number }> {
    const query = params
      ? `?${new URLSearchParams(params as Record<string, string>).toString()}`
      : '';

    const result = CallbackCatch
      ? await BaseService.Get(`/job-applications${query}`, CallbackCatch, false)
      : await BaseService.Get(`/job-applications${query}`);

    if (!result) {
      return { content: [], totalElements: 0 };
    }

    return {
      content: Array.isArray(result.content) ? result.content : [],
      totalElements: result.totalElements ?? 0,
    };
  }

  static async GetApplicationsById(
    id: string,
    CallbackCatch: (error: Error) => void
  ): Promise<JobApplication[]> {
    return await BaseService.Get(
      `/featured/jobs/${id}/job-applications`,
      CallbackCatch,
      false
    );
  }

  static async GetById(
    id: string,
    CallbackCatch?: (error: Error) => void
  ): Promise<JobApplication> {
    return await BaseService.Get(
      `/job-applications/${id}`,
      CallbackCatch,
      false
    );
  }

  static async GetFile(id: string, fileId: string): Promise<Blob> {
    return await BaseService.Blob(
      'GET',
      `/job-applications/${id}/files/${fileId}`,
      undefined,
      undefined,
      false
    );
  }

  static async Add(
    id: string,
    status: JobApplicationStatus,
    notifiable: boolean
  ): Promise<JobApplication> {
    return await BaseService.Post(`/job-applications/${id}/statuses`, {
      status: status.statusName,
      content: status.note,
      notifiable,
    });
  }
}
